import { createImagesApi } from '~/entities/image/api/images-api'

export const listingImagesApi = createImagesApi('listings')
